import { toast } from "react-toastify";

import {
  GetExperienceResponseBodyType,
  PatchVariationsRequestBodyType,
  PatchVariationsResponseBodyType,
} from "@intelligems/ig-types";
import {
  QueryObserverOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";

import { api } from "../api";
import { experienceKeys, historyKeys } from "../queryKeys";

const patchVariations = async (data: PatchVariationsRequestBodyType) => {
  const resp = await api.patch<
    PatchVariationsResponseBodyType,
    PatchVariationsRequestBodyType
  >(`/v2/bulk/variations`, data);

  return resp.data;
};
export const usePatchVariations = (
  category: "personalization" | "experiment",
  experienceId?: string,
  options?: QueryObserverOptions<PatchVariationsResponseBodyType, Error>
) => {
  const queryClient = useQueryClient();

  return useMutation<
    PatchVariationsResponseBodyType,
    Error,
    PatchVariationsRequestBodyType
  >({
    mutationKey: ["patchVariations"],
    mutationFn: async (data) => patchVariations(data),
    onSuccess: async (data) => {
      if (experienceId) {
        queryClient.setQueryData(
          experienceKeys.one(experienceId),
          (oldData) => {
            const res: GetExperienceResponseBodyType = {
              experience: {
                ...(oldData as GetExperienceResponseBodyType).experience,
                variations: data.variations,
              },
            };
            return res;
          }
        );
        void queryClient.invalidateQueries({
          queryKey: historyKeys.one(experienceId),
        });
        await queryClient.invalidateQueries({
          queryKey:
            category === "personalization"
              ? experienceKeys.personalizationList
              : experienceKeys.experimentList,
        });
      }
      toast.success("Test groups updated!");
    },
    onError: () => {
      toast.error("Error updating test groups.");
    },
  });
};
